import React from 'react';
import PropTypes from 'prop-types';
import { Collapse } from 'antd';

const { Panel } = Collapse;

export default function BudgetTrackingCollapse({
  panelKey,
  header,
  children,
  defaultOpen,
}) {
  return (
    <Collapse
      collapsible="icon"
      bordered={false}
      defaultActiveKey={defaultOpen ? [panelKey] : []}
    >
      <Panel
        header={header}
        key={panelKey}
        className="budget-tracking-border"
      >
        {children}
      </Panel>
    </Collapse>
  );
}

BudgetTrackingCollapse.propTypes = {
  panelKey: PropTypes.string.isRequired,
  header: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  defaultOpen: PropTypes.bool,
};

BudgetTrackingCollapse.defaultProps = {
  defaultOpen: true,
};
